import { put, take } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import { galleryRef } from '../../database'
import { onSnapshot } from 'firebase/firestore'

import { updateGallery, removeGallery } from '../actions'

export let gallerySnap

export function* loadGallerySaga() {
  try {
    const listener = eventChannel((emit) => {
      gallerySnap = onSnapshot(galleryRef, (querySnapshot) => {
        querySnapshot.docChanges().forEach((change) => {
          emit(change)
        })
      })
      return () => gallerySnap()
    })
    while (true) {
      const change = yield take(listener)
      const data = change.doc.data()
      const id = change.doc.id
      if (id === '_._') continue
      if (change.type === 'added') {
        yield put(updateGallery({ id, ...data }))
      }
      if (change.type === 'modified') {
        yield put(updateGallery({ id, ...data }))
      }
      if (change.type === 'removed') {
        yield put(removeGallery({ id, ...data }))
      }
    }
  } catch (error) {
    console.log(error)
  }
}
